import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { WS_BASE_URL } from '../config'

/**
 * Custom hook for managing WebSocket connection to user profile updates
 * @param {number|null} userId - The user ID to connect to
 * @param {boolean} isAuthenticated - Whether the user is authenticated
 * @returns {Object} - { wsConnected: boolean, wsRef: RefObject }
 */
const useUserWebSocket = (userId, isAuthenticated) => {
  const dispatch = useDispatch()
  const [wsConnected, setWsConnected] = useState(false)
  const wsRef = useRef(null)

  useEffect(() => {
    if (!userId || !isAuthenticated) {
      return
    }

    const wsUrl = `${WS_BASE_URL}/ws/user/${userId}/`

    console.log('Connecting to WebSocket:', wsUrl)

    const ws = new WebSocket(wsUrl)
    wsRef.current = ws

    ws.onopen = () => {
      console.log('WebSocket connected')
      setWsConnected(true)
    }

    ws.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data)
        console.log('WebSocket message received:', message)

        if (message.type === 'user_initial' || message.type === 'user_updated') {
          dispatch({
            type: 'FETCH_PROFILE_SUCCESS',
            payload: {
              ...message.data,
              gender: message.data.gender?.name || message.data.gender,
              user_type: message.data.user_type?.name || message.data.user_type,
              subscription_type: message.data.subscription_type?.name || message.data.subscription_type
            }
          })

          if (message.type === 'user_updated') {
            console.log('Profile updated in real-time!')
          }
        }
      } catch (error) {
        console.error('Error parsing WebSocket message:', error)
      }
    }

    ws.onerror = (error) => {
      console.error('WebSocket error:', error)
      setWsConnected(false)
    }

    ws.onclose = () => {
      console.log('WebSocket disconnected')
      setWsConnected(false)
    }

    return () => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.close()
      }
    }
  }, [userId, isAuthenticated, dispatch])

  return { wsConnected, wsRef }
}

export default useUserWebSocket
